<div class="add-on" [ngClass]="{'add-on--hidden': !(addon$ | async)}">
  @if (showRecommendation$ | async) {
    <se-fe-alert seFeDataType="info">
      Recommended add-on
      <se-fe-alert-subheader class="alert-subheader">
        {{ (orgName$ | async) || 'Your organization' }} recommends
        <strong>Refund Protection</strong>
        to cover your registration payment if your athlete cannot play due to
        illness, injury, or other unexpected circumstances.
      </se-fe-alert-subheader>
    </se-fe-alert>
  }
  <ng-template appRenderTarget></ng-template>
</div>
